import officerInviteApi from '../services/api/officerInviteApi';
import navigator from '../services/ui/navigator';
import ssoApi from '../services/api/ssoApi';

export const INVITE_INVALID = 'ACCOUNT/INVITE_INVALID';
export const INVITE_REFRESHED = 'ACCOUNT/INVITE_REFRESHED';
export const SIGNED_UP_USER_REFRESHED = 'ACCOUNT/SIGNED_UP_USER_REFRESHED';
export const RESET = 'ACCOUNT/RESET';
export const EMAIL_EXISTS_REFRESHED = 'ACCOUNT/EMAIL_EXISTS_REFRESHED';
export const TOGGLE_IS_LOADING_INVITE = 'ACCOUNT/TOGGLE_IS_LOADING_INVITE';

export const signedUpUserRefreshed = (signedUpUser) => ({
    type: SIGNED_UP_USER_REFRESHED,
    signedUpUser,
});

export const emailExistsRefreshed = (emailExists) => ({
    type: EMAIL_EXISTS_REFRESHED,
    emailExists,
});

export const isLoadingInviteToggled = (isLoadingInvite) => ({
    type: TOGGLE_IS_LOADING_INVITE,
    isLoadingInvite,
});

export const inviteRefreshed = (invite) => ({ type: INVITE_REFRESHED, invite });

export const reset = () => ({ type: RESET });

export const invalidInvite = () => ({ type: INVITE_INVALID });

export const getInviteByToken = (token) => async (dispatch) => {
    try {
        dispatch(isLoadingInviteToggled(true));

        const {
            data: { data: invite },
        } = await officerInviteApi.getInviteByToken(token);

        const {
            data: { data: emailExists },
        } = await ssoApi.getEmailExists(invite.email);

        dispatch(inviteRefreshed(invite));
        dispatch(emailExistsRefreshed(emailExists));
    } catch ({ response }) {
        dispatch(invalidInvite());
    } finally {
        dispatch(isLoadingInviteToggled(false));
    }
};
